import ReportDocumentHeader from '@/components/Reports/ReportPrivate/_comons/ReportDocumentHeader';
import { useWorkOrder } from '@/core/domain/workorder/WorkOrders/WorkOrders.hooks';
import { useRouteMatchParam } from '@/hooks';
import { Button, DatePicker, TimePicker } from 'antd';
import moment from 'moment';
import React, { lazy } from 'react';
import { useRouteMatch } from 'react-router';
import {
  InspectionRecordHeader,
  InspectionRecordList,
} from '@/components/Reports/ReportPrivate/InspectionRecord';
import { Group } from '@/components/_common';

const TemplateReport = lazy(
  () => import('@/components/_common/TemplateReport/TemplateReport'),
);

import './inspectionRecord.less';
import TextArea from 'antd/lib/input/TextArea';
import { convertParams } from '@/utils/queryParams';
import { useCompanyReportConfig } from '@/core/domain/enterprise/Companies/CompaniesReportConfig/CompaniesReportConfig.hooks';
import { DefaultName } from '@/core/domain/reports/company/Company.types';
import { useCompanies } from '@/core/domain/enterprise/Companies/Companies.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';

const InspectionRecord: React.FC = () => {
  const match = useRouteMatch();
  const companyIdParam = useRouteMatchParam('companyId');
  const obj = convertParams<{ workOrderId: number; print: boolean }>({
    workOrderId: 'number',
    print: 'boolean',
  });

  const { data } = useCompanies({ rows: 50 });

  const companies = flatInfiniteData(data);

  const company = companies.find(
    (company) => company.id === Number(companyIdParam),
  );

  const { data: configCompany } = useCompanyReportConfig(companyIdParam);

  const { data: workorderData } = useWorkOrder(obj.workOrderId);

  document.title = `ficha_de_inspecao_tecnica_${moment().format(
    'DDMMYYYY_HHmmss',
  )}`;

  return (
    <React.Suspense fallback={<>Carregando documento...</>}>
      {match.isExact && !!company && !!configCompany && (
        <TemplateReport>
          <main
            className="report-inspection-record"
            onLoad={() => {
              if (obj.print) {
                window.print();
              }
            }}
          >
            <div className="button-print display-none-to-print">
              <Button type="primary" onClick={() => window.print()}>
                Imprimir
              </Button>
            </div>

            <ReportDocumentHeader
              title={
                configCompany.companyNaming === DefaultName.fantasyName
                  ? company.nickName
                  : company.name
              }
              company={{
                name: 'Ficha de Inspeção Técnica',
                logo: company.logo,
              }}
            />

            <InspectionRecordHeader workorderData={workorderData} />

            <table style={{ marginBottom: 12 }}>
              <thead>
                <tr>
                  <th>Data/Hora Inicial</th>
                  <th>Data/Hora Final</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  {Array.from({ length: 2 }).map((_, index) => (
                    <td>
                      <Group key={index} gap={10} className="time">
                        <DatePicker placeholder="" format="DD/MM/YYYY" />
                        <TimePicker placeholder="" format="HH:mm:ss" />
                      </Group>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>

            <InspectionRecordList />

            <table>
              <thead>
                <tr>
                  <th>Observações</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <TextArea rows={8} />
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="footer">
              <div>Coordenador</div>
              <div>Técnico responsável</div>
            </div>
          </main>
        </TemplateReport>
      )}
    </React.Suspense>
  );
};

export default InspectionRecord;
